import React from 'react';

import cmmcDiscoverIcon from '../../assets/images/cmmc__discover_icon.png';
import cmmcProtectIcon from '../../assets/images/cmmc__protect_icon.png';
import cmmcAuditIcon from '../../assets/images/cmmc__audit_icon.png';

const CMMCIntroduction = () => {
  return (
    <div className="w-full rounded rounded-lg bg-[#010511] my-6">

      <h1 className="text-3xl text-white font-bold text-center pt-6 mt-6 mx-28">Create a robust security framework to safeguard your CUI and ensure adherence to NIST 800-171 controls for CMMC compliance.</h1>

      <h3 className="text-lg text-white pt-12 mb-4 text-center" style={{ letterSpacing: ".5rem" }}>
        CMMC COMPLIANCE PROCESS
      </h3>

      <div className="flex flex-col lg:flex-row items-stretch justify-center mt-6 pb-28 mx-28 space-y-6 lg:space-y-0 lg:space-x-6">

        <div className="rounded rounded-md bg-white w-full lg:w-1/3 pb-8 flex flex-col lg:flex-1">
          <img
            src={cmmcDiscoverIcon}
            alt="UNDERSTAND WORKFLOW NEEDS"
            className="mx-auto"
          />
          <h3 className="text-2xl text-black text-center mx-12 py-5">UNDERSTAND WORKFLOW NEEDS</h3>
          <ul className="text-md text-black mx-12 list-disc space-y-4 mb-4 flex-grow">
            <li>Analyze personnel roles, responsibilities, and security clearances for federal contracts to ensure compliance with DoD requirements for protecting Controlled Unclassified Information (CUI).</li>
            <li>Evaluate Federal Contract Information (FCI), Covered Defense Information (CDI), and CUI to define secure workspaces and data handling procedures that meet CMMC standards.</li>
            <li>Design a tailored technology stack with hardware, software, and cloud solutions to support FCI and CUI security aligned with CMMC maturity levels and NIST 800-171 controls.</li>
          </ul>
        </div>

        <div className="rounded rounded-md bg-white w-full lg:w-1/3 pb-8 flex flex-col lg:flex-1">
          <img
            src={cmmcProtectIcon}
            alt="IMPLEMENT & DOCUMENT CMMC"
            className="mx-auto"
          />
          <h3 className="text-2xl text-black text-center mx-12 py-5">IMPLEMENT & DOCUMENT CMMC</h3>
          <ul className="text-md text-black mx-12 list-disc space-y-4 mb-4 flex-grow">
            <li>Deploy a CMMC-compliant security framework with technical and procedural controls to protect CUI, based on assessed workflow needs and required maturity levels.</li>
            <li>Generate detailed documentation, including System Security Plans (SSPs) and incident response plans, to demonstrate CMMC and NIST 800-171 compliance for DoD assessments.</li>
            <li>Train staff on custom security measures, CUI handling protocols, and incident reporting to ensure effective implementation and compliance with CMMC requirements.</li>
          </ul>
        </div>

        <div className="rounded rounded-md bg-white w-full lg:w-1/3 pb-8 flex flex-col lg:flex-1">
          <img
            src={cmmcAuditIcon}
            alt="AUDIT CMMC COMPLIANCE"
            className="mx-auto"
          />
          <h3 className="text-2xl text-black text-center mx-12 py-5">AUDIT CMMC COMPLIANCE</h3>
          <ul className="text-md text-black mx-12 list-disc space-y-4 mb-4 flex-grow">
            <li>Assess the organization's security controls against NIST 800-171 and CMMC maturity level requirements to verify compliance and identify gaps in CUI protection.</li>
            <li>Document audit findings and non-conformities, creating a Plan of Action and Milestones (POA&M) to outline remediation steps for achieving CMMC compliance.</li>
            <li>Implement continuous monitoring and periodic reviews to maintain CMMC compliance, using automated tools and audits to adapt to evolving threats and requirements.</li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default CMMCIntroduction;